var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
export default React.memo(function (props) {
    return (React.createElement("svg", __assign({ width: 48, height: 48, viewBox: "0 0 48 48", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { d: "M24 12c2.728 0 4.954 2.017 5.072 4.547l.005.212h4.677c.688 0 1.246.532 1.246 1.19 0 .656-.558 1.189-1.246 1.189l-.569-.001.001 13.881-.003.075-.008.073c-.112 1.663-1.063 2.748-2.707 2.83l-.2.004h-12.93c-1.544 0-2.345-1.047-2.484-2.647l-.014-.203a1.13 1.13 0 01-.008-.132V19.137h-.586c-.688 0-1.246-.532-1.246-1.189s.558-1.19 1.246-1.19h4.677C18.923 14.132 21.196 12 24 12zm6.961 7.137h-2.942v14.69h2.135c.284 0 .741-.063.801-.657l.006-14.033zm-10.932 0h-2.991v13.658a1 1 0 001 1h1.991V19.137zm5.808 0h-3.644v14.66h3.644v-14.66zm-1.824-4.863a2.5 2.5 0 00-2.5 2.5h5a2.5 2.5 0 00-2.5-2.5z", fill: "currentColor", stroke: "none", strokeWidth: 1, fillRule: "evenodd" })));
});
